import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCake: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11.5H13.8333V6.66663C13.8333 5.05329 12.9467 4.16663 11.3333 4.16663H11.1667V2.66663C11.1667 2.39329 10.94 2.16663 10.6667 2.16663C10.3933 2.16663 10.1667 2.39329 10.1667 2.66663V4.16663H8.5V2.66663C8.5 2.39329 8.27333 2.16663 8 2.16663C7.72667 2.16663 7.5 2.39329 7.5 2.66663V4.16663H5.83333V2.66663C5.83333 2.39329 5.60667 2.16663 5.33333 2.16663C5.06 2.16663 4.83333 2.39329 4.83333 2.66663V4.16663H4.66667C3.05333 4.16663 2.16667 5.05329 2.16667 6.66663V11.5H2C1.72667 11.5 1.5 11.7266 1.5 12V13C1.5 13.8266 2.17333 14.5 3 14.5H13C13.8267 14.5 14.5 13.8266 14.5 13V12C14.5 11.7266 14.2733 11.5 14 11.5ZM4.66667 5.16663H11.3333C12.3867 5.16663 12.8333 5.61329 12.8333 6.66663V7.43329C12.34 7.63329 11.9133 8.08663 11.6067 8.49996C11.2467 7.95329 10.6467 7.33329 9.78001 7.33329C8.91334 7.33329 8.36667 7.89996 8.00667 8.42663C7.64001 7.89996 7.06 7.33329 6.23334 7.33329C5.40667 7.33329 4.76666 7.95329 4.40666 8.49996C4.09999 8.08663 3.66666 7.63329 3.17999 7.43329V6.66663C3.17999 5.61329 3.62666 5.16663 4.67999 5.16663H4.66667ZM3.16667 8.61329C3.47333 8.89996 3.8 9.35996 4 9.7333C4.09333 9.90663 4.28 10.0133 4.48 9.9933C4.68 9.97996 4.84666 9.84663 4.91333 9.66663C4.91333 9.65329 5.42 8.33329 6.22666 8.33329C7.03333 8.33329 7.52666 9.65329 7.53333 9.66663C7.60666 9.86663 7.79334 9.99996 8.00667 9.99996C8.22001 9.99996 8.40667 9.86663 8.48 9.66663C8.6 9.31996 9.1 8.33329 9.78666 8.33329C10.5933 8.33329 11.0933 9.65329 11.1 9.66663C11.1667 9.85329 11.34 9.97996 11.5333 9.9933C11.74 10.0133 11.92 9.90663 12.0133 9.7333C12.2133 9.35996 12.54 8.90662 12.8467 8.61329V11.5H3.17999V8.61329H3.16667ZM13.5 13C13.5 13.2733 13.2733 13.5 13 13.5H3C2.72667 13.5 2.5 13.2733 2.5 13V12.5H13.5V13Z"
      fill={color}
    />
  </svg>
);

export default IconCake;
